module.exports = __webpack_public_path__ + "63f71da7cd65dfd5e0c67a92dffb0f7a.png";